export default "__VITE_ASSET__fac9b6a6__"